import { isPlatformBrowser } from "@angular/common";
import { Injectable, inject, PLATFORM_ID } from "@angular/core";
import { HttpClient } from "@angular/common/http";

/**
 * Bump `currentVersion` on every release to match `src/assets/version.json`.
 * After deploy, only `version.json` on the server is updated; old bundles detect mismatch and reload.
 */
@Injectable({
  providedIn: "root",
})
export class VersionCheckService {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);

  /** Must match `src/assets/version.json` at build time. */
  private readonly currentVersion = "1.6.8";

  private bfCacheListenerAttached = false;

  checkVersion(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!this.bfCacheListenerAttached) {
      this.bfCacheListenerAttached = true;
      window.addEventListener("pageshow", (event: PageTransitionEvent) => {
        if (event.persisted) {
          this.fetchServerVersionAndReloadIfStale();
        }
      });
    }
    this.fetchServerVersionAndReloadIfStale();
  }

  private fetchServerVersionAndReloadIfStale(): void {
    this.http
      .get<{ version?: string }>(`assets/version.json?t=${Date.now()}`)
      .subscribe({
        next: (response) => {
          const serverVersion = response?.version?.trim();
          if (
            serverVersion &&
            serverVersion !== this.currentVersion
          ) {
            window.location.reload();
          }
        },
        error: () => {
          // Fail open: do not reload if version file is missing (e.g. local dev misconfig).
        },
      });
  }
}
